<template>
  <div class="profileContainer">
    <div class="grid imgGrid">
      <p class="nunitoBold accountText mt-5">
        {{ $t('k_account_title') }}
      </p>
      <h2 class="hrLine"></h2>
      <p class="ralewayRegular accountText2">
        {{ $t('k_general_info') }}
      </p>
      <div class="emailContainer">
        <p class="ralewayRegular emailText">
          {{ email }}
        </p>
        <p v-on:click="changePassword()" class="ralewayBold changePasswordText">
          {{ $t('k_change_password_title') }}
        </p>
      </div>
      <h2 class="hrLine2"></h2>
      <p class="ralewayRegular accountText3">
        {{ $t('k_plan_detail') }}
      </p>
      <p class="ralewayBold planText">
        {{ this.premium ? 'Smart Tales PREMIUM' : 'Smart Tales BASIC' }}
      </p>
      <h2 class="hrLine3"></h2>
    </div>
    <div class="grid mt-5" v-if="!premium">
      <div class="stButton premiumButton">
        <div class="stButtonCaption nunitoBold" v-on:click="goPremium()">
          {{ $t('k_go_premium') }}
        </div>
      </div>
      <div class="stSecondaryButton premiumButton mt-5">
        <div class="stButtonCaption nunitoBold" v-on:click="goCoupon()">
          {{ $t('k_redeem_coupon') }}
        </div>
      </div>
      <div class="stSecondaryButton premiumButton mt-5">
        <div class="stButtonCaption nunitoBold" v-on:click="goGiftCard()">
          {{ $t('k_redeem_gift') }}
        </div>
      </div>
      <div class="stSecondaryButton premiumButton mt-5">
        <div class="stButtonCaption nunitoBold" v-on:click="goCoupon()">
          {{ $t('k_redeem_license') }}
        </div>
      </div>
      <p class="ralewayRegular helpText">
        {{ $t('k_help_title') }}
        <span class="ralewayBold"
          ><a href="mailto:support@smart-tales.freshdesk.com"
            >support@smart-tales.freshdesk.com</a
          ></span
        >
      </p>
    </div>
    <div v-else class="">
      <div
        class="subsGrid"
        v-for="(item, index) in subscriptions"
        :key="item.identifier"
      >
        <p class="subTitle ralewayRegular">
          {{ getSubDescription(item) }}
          <span class="ralewayBold">{{ getSubDescriptionBold(item) }}</span>
        </p>
        <div class="subExpire ralewayRegular">
          {{ `${$t('k_expire_profile')}` }}
          <span class="ralewayBold subExpireDate">{{
            `  ${moment(item.expires_date).format('DD/MM/YYYY')} `
          }}</span>
        </div>
        <p
          class="subManage ralewayBold"
          v-if="item.identifier != 'giftCard' && !item.unsubscribe_detected_at"
          v-on:click="onClickManageSub(item)"
        >
          {{ $t(`k_edit_plan`) }}
        </p>
        <h2
          class="hrLineSub"
          v-if="subscriptions && index != subscriptions.length - 1"
        ></h2>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '../plugins/api'
import { trackEvent } from '../plugins/analyticsTracker'
import { getRedirectAfterRegisterLogin } from '../services/redirectHelper'

export default {
  data() {
    return {
      userInfo: '',
      password: '',
      submitted: false,
      premium: false,
      revenuecatData: {},
      subscriptions: [],
      query: null
    }
  },
  mounted() {
    this.query = this.$route.query
    const path = getRedirectAfterRegisterLogin(this.query)
    if (path != '/profile')
      this.$router.push({
        path: path,
        query: this.query
      })
  },
  computed: {
    ...mapState({
      email: state => state.userInfo?.email,
      coupons: state => state.userInfo?.coupons
    })
  },
  async created() {
    const urlGet = process.env.VUE_APP_BACKEND_URL
    const revenuecatRespone = await api.get(`${urlGet}/user/revenueCat`)
    const subs =
      revenuecatRespone &&
      revenuecatRespone.data &&
      revenuecatRespone.data.subscriptions
        ? revenuecatRespone.data.subscriptions
        : []
    this.subscriptions = [...this.subscriptions, ...subs]
    const validCoupon = this.coupons.find(
      x =>
        x.duration &&
        x.registrationDate &&
        this.moment(x.registrationDate)
          .add(x.duration, 'days')
          .diff(this.moment(), 'days') > 0
    )
    if (validCoupon)
      this.subscriptions = [
        ...this.subscriptions,
        {
          identifier: 'giftCard',
          duration: validCoupon.duration,
          expires_date: this.moment(validCoupon.registrationDate)
            .add(validCoupon.duration, 'days')
            .toDate()
        }
      ]
    this.premium =
      this.subscriptions.length > 0 &&
      this.subscriptions.some(x => !x.unsubscribe_detected_at)
  },
  methods: {
    goCoupon() {
      trackEvent(this.$constants.WEB_ACC_REDEEM_PROMO)
      this.$router.push('coupon')
    },
    goGiftCard() {
      trackEvent(this.$constants.WEB_ACC_REDEEM_GIFT)
      this.$router.push('coupon')
    },
    goPremium() {
      trackEvent(this.$constants.WEB_ACC_UPGRADE_PREMIUM)
      this.$router.push('payment')
    },
    changePassword() {
      trackEvent(this.$constants.WEB_ACC_FORGOT_PWD)
      this.$router.push('change-password')
    },
    submit: async function() {
      this.$router.push({ path: '/coupon' })
    },
    onClickManageSub(sub) {
      trackEvent(this.$constants.WEB_ACC_MANAGE_SUBS)
      if (sub.store == 'stripe')
        this.$router.push({
          path: 'cancel-plan',
          query: { subscriptionId: sub.id }
        })
      else if (sub.store == 'app_store' || sub.store == 'mac_app_store')
        window.location = 'https://support.apple.com/en-us/HT202039'
      else if (sub.store == 'play_store')
        window.location = 'https://support.google.com/googleplay/answer/7018481'
    },
    getSubDescription(sub) {
      if (sub.identifier == 'giftCard') {
        return this.$i18n.t('k_giftcard_description')
      } else return this.$i18n.t('k_stripe_profile_payment')
    },
    getSubDescriptionBold(sub) {
      if (sub.identifier == 'giftCard') {
        //duration months
        const diff = Math.ceil(
          this.moment(sub.expires_date).diff(this.moment(), 'days') / 30
        )
        return `${diff} ${this.$i18n.t('k_profile_months')}`
      } else return this.$i18n.t('k_stripe_profile_payment_cc')
    }
  }
}
</script>
<style lang="scss">
.profileContainer {
  .subTitle {
    grid-column: 2/4;
    text-align: left;
    color: var(--formColor);
    font-size: 0.8em;
    line-height: 1.3em;
  }

  .subExpire {
    grid-column: 2/4;
    text-align: left;
    color: var(--formColor);
    font-size: 0.8em;
    line-height: 1.3em;
  }

  .subExpireDate {
    grid-column: 2/4;
    text-align: left;
    color: var(--formColor);
    font-size: 0.8em;
    line-height: 1.3em;
  }

  .subManage {
    grid-row: 1;
    grid-column: 8/11;
    text-align: left;
    color: var(--primary);
    font-size: 0.875em;
    line-height: 1.3em;
    cursor: pointer;
  }

  .subsGrid {
    display: grid;
    row-gap: 4px;
    grid-template-columns: repeat(12, 1fr);
  }

  .helpText {
    margin: 20px 0;
    color: var(--formColor);
    grid-row: 5;
    grid-column: 2/12;
    font-size: 0.7em;
    text-align: left;
  }
  .emailContainer {
    display: flex;
    flex-direction: column;
    grid-row: 3;
    grid-column: 8/12;
    align-items: flex-start;
  }
  .imgGrid {
    align-self: center;
  }
  .accountText {
    grid-row: 1;
    grid-column: 2/4;
    font-size: 1.5em;
    color: var(--tertiary);
    line-height: 1.3em;
    text-align: left;
  }

  .accountText2 {
    grid-row: 3;
    grid-column: 2/4;
    font-size: 0.875em;
    color: var(--formColor);
    text-align: left;
    line-height: 1.3em;
  }

  .accountText3 {
    grid-row: 5;
    grid-column: 2/4;
    font-size: 0.875em;
    color: var(--formColor);
    text-align: left;
    line-height: 1.3em;
  }

  .emailText {
    grid-row: 3;
    grid-column: 2/11;
    font-size: 0.875em;
    color: var(--tertiary);
    text-align: left;
    line-height: 1.3em;
  }

  .planText {
    display: flex;
    grid-row: 5;
    grid-column: 8/12;
    font-size: 0.875em;
    color: var(--tertiary);
    text-align: right;
    line-height: 1.3em;
  }

  .changePasswordText {
    grid-row: 3;
    grid-column: 2/11;
    font-size: 0.75em;
    color: var(--primary);
    text-align: left;
    cursor: pointer;
  }

  .imgGrid .subheaderText {
    grid-row: 2;
    grid-column: 1/9;
    font-size: 1.56em;
    color: var(--secondary);
  }

  .premiumButton {
    grid-column: 3/11;
    padding: 10px 0px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .stButtonCaption {
    grid-column: 1/13;
    font-size: 0.9em;
  }

  .hrLine {
    width: 100%;
    text-align: center;
    border-bottom: 2px solid var(--line1);
    line-height: 0.1em;
    margin: 10px 0 20px;
    grid-row: 2;
    grid-column: 2/12;
  }

  .hrLineSub {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid var(--line2);
    line-height: 0.1em;
    margin: 10px 0 20px;
    grid-column: 2/12;
  }

  .hrLine2 {
    width: 100%;
    text-align: center;
    border-bottom: 2px solid var(--line1);
    line-height: 0.1em;
    margin: 10px 0 20px;
    grid-row: 4;
    grid-column: 2/12;
  }

  .hrLine3 {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid var(--line2);
    line-height: 0.1em;
    margin: 20px 0 20px;
    grid-row: 6;
    grid-column: 2/12;
  }

  .hrLine span {
    padding: 0 10px;
    background: #fff;
    color: var(--line1);
    font-size: 0.5em;
  }

  .formContainer {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .formElement {
    grid-column: 2/12;
  }

  .formInputLabel {
    display: flex;
    font-size: 1em;
    color: var(--formColor);
  }
  .formInput {
    padding: 10px 15px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 1em;
    color: var(--formColor);
  }

  .checkboxLabel {
    font-size: 0.688em;
    color: var(--formColor);
    grid-column: 3/8;
  }

  .accept {
    display: flex;
    grid-column: 2/3;
    align-self: center;
  }
  @media screen and (min-width: 620px) {
  }
  /* large tablet and laptop styles */
  @media screen and (min-width: 960px) {
  }
  /* desktop styles */
  @media screen and (min-width: 1200px) {
  }
}
</style>
